export default __webpack_public_path__ + "static/media/check.215a4049.svg";